import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { getFiltersForGroups } from '../actions/communication';
import GroupMessages from '../components/communication/GroupMessages';
import IndividualMessages from '../components/communication/IndividualMessages';
import CommunicationSubNav from '../components/nav/CommunicationSubNav';
import SubNavBar from '../containers/nav/SubNavBar';
import TopNavBar from '../containers/nav/TopNavBar';
import { appNamedRoutes } from '../routes';

const CommunicationPage = ({
  auth,
  getFiltersForGroups,
}) => {
  useEffect(() => {
    getFiltersForGroups();
  }, []);

  return (
    <DocumentTitle title="Messaging">
      <div className="page-container o-communication">
        <TopNavBar auth={auth}/>
        <SubNavBar/>
        <CommunicationSubNav/>

        <div className="o-communication__container">
          <div className="o-communication__main-content">
            <Switch>
              <Route path={appNamedRoutes.communicationIndividuals} exact component={IndividualMessages}/>
              <Route path={appNamedRoutes.communicationGroups} exact component={GroupMessages}/>
            </Switch>
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
};

CommunicationPage.propTypes = {
  auth: PropTypes.object.isRequired,
  getFiltersForGroups: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getFiltersForGroups,
})(CommunicationPage);
